export default "__VITE_ASSET__CcVc62Jz__"